module.exports = __webpack_public_path__ + "img/logo.43d24f8c.png";